/**
 * HOOK: usePricingProducts
 * Select léger des éditions pour l'écran /admin/pricing : id, nom et état de
 * confirmation de la grille (badge Brouillon/Confirmée). Le refresh est
 * appelé après toute mutation d'item — le trigger DB a pu déconfirmer.
 */

import { useSelectData } from './useSelectData';

export interface PricingProduct {
  id: string;
  name: string;
  pricing_confirmed: boolean;
  pricing_confirmed_at: string | null;
}

export function usePricingProducts() {
  const { data, loading, error, refresh } = useSelectData(
    'products',
    'id, name, pricing_confirmed, pricing_confirmed_at',
    'name',
    true
  );

  return {
    products: data as unknown as PricingProduct[],
    loading,
    error,
    refresh,
  };
}
